import styled from 'styled-components';

import { RewardsStyleVariant } from './reward-categories/types';

export const BackgroundWrapper = styled.div`
  background-color: ${Styles.color.primary};
  padding-left: 1rem;
  padding-right: 1rem;
`;

export const Background = styled.div`
  background: linear-gradient(
    ${Styles.color.primary} 0 243px,
    ${Styles.color.background} 243px 100%
  );

  ${Styles.mobileTiny`
    background: linear-gradient(
      ${Styles.color.primary} 0 230px,
      ${Styles.color.background} 230px 100%
    );
  `}

  ${Styles.desktop`
    background: linear-gradient(${Styles.color.primary} 0 272px, ${Styles.color.background} 272px 100%);
  `}
`;

export const SectionDescription = styled.div`
  color: ${Styles.color.white};
  text-align: center;
  margin: 1rem 0;

  ${Styles.mobileTiny`
    font-size: 0.875rem;
  `}
`;

export const SectionHeader = styled.h2<{ variant?: RewardsStyleVariant }>`
  margin: 0;
  padding-top: 16px;
  text-align: center;
  font-size: 1.5rem;
  color: ${({ variant = RewardsStyleVariant.Primary }) =>
    variant === RewardsStyleVariant.Primary ? Styles.color.white : Styles.color.secondary};

  ${Styles.mobileTiny`
    font-size: 1.375rem;
  `}
`;

export const SectionHeaderWrapper = styled.div`
  ${Styles.desktop`
    margin-bottom: 4rem;
  `}
`;

export const TableContainer = styled.div`
  margin: 1rem auto;
`;

export const TabContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  background-color: ${Styles.color.primary};

  button {
    font-weight: ${Styles.fontWeight.heavy};
  }

  ${Styles.desktop`
    padding-top: 6.9rem;
  `};
`;

export const TabInner = styled.div`
  display: flex;
  width: 400px;
`;

export const TabContentContainer = styled.div`
  width: 90%;
  margin: 0 auto;
  padding-bottom: 40px;
  max-width: 660px;
  min-height: calc(100vh - 107px);

  ${Styles.desktop`
    padding-bottom: 60px;
  `}
`;
